import Toastify from 'toastify-js'

const DEFAULT_INFO_TEXT = 'Oops. Something went wrong... Try again later.';

function infoMessage(text, cssClass = 'info') {
    Toastify({
        backgroundColor: '#ffffff',
        className: cssClass,
        text: text || DEFAULT_INFO_TEXT,
        duration: 3500,
        close: true,
        stopOnFocus: true,
        onClick: function () {
        } // Callback after click
    }).showToast();
}

function errorMessage(text = DEFAULT_INFO_TEXT) {
    Toastify({
        text: text || DEFAULT_INFO_TEXT,
        duration: 3000,
        newWindow: true,
        close: true,
        width: 400,
        gravity: "top", // `top` or `bottom`
        position: "right", // `left`, `center` or `right`
        backgroundColor: "rgba(255,0,60,0.73)",
        stopOnFocus: true, // Prevents dismissing of toast on hover
        onClick: function () {
        } // Callback after click
    }).showToast();
}

export {infoMessage, errorMessage};
